<template>
  <div :class="$vuetify.breakpoint.mobile ? 'mcmp-footer cmp-footer':'cmp-footer'">
    <div :class="$vuetify.breakpoint.mobile ? 'mf-text f-text':'f-text'">
        <p>艾影（上海）有限公司</p>
        <p>Animation International (Shanghai) Ltd. 2020 ANIMATION ALL RIGHT RESERVED</p>
    </div>
    <p :class="$vuetify.breakpoint.mobile ? 'mf-text f-text':'f-text'">
      沪ICP备09018167号-5
    </p>
    <img src="../../assets/foooterLogo.png" alt="">
  </div>
</template>

<script>
  export default {
    data() {
      return {
        
      }
    },
  }
</script>

<style lang="scss" scoped>
    .mcmp-footer{
      justify-content: center!important;
      padding: 10px!important;
      flex-direction: column;
      img{
        height: 5rem!important;
        margin: 2rem auto;
      }
    }
    .mf-text{
      text-align: center;
      margin-bottom: 10px;
      // font-size: 2rem!important;
    }
    .cmp-footer{
        // position: fixed;
        // bottom: 0;
        width: 100vw;
        min-height: 80px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        background: #c72f3b;
        padding: 20px 50px;
        img{
            // width: 200px;
            height: 40px;
        }
    }
    .f-text{
        font-size: 12px;
        display: flex;
        flex-direction: column;
        color: #fff;
    }
    
</style>